<template>
  <div class="user-data-account">
    <h2>{{ $t('component.userData.account.header') }}</h2>

    <section class="data-table">
      <section class="data-header">
        <div class="data-col col1">{{ $t('component.userData.account.labelEmail') }}</div>
        <div class="data-col col2">{{ $t('component.userData.account.labelPassword') }}</div>
        <div class="data-col col3"></div>
      </section>
      <section class="data-content">
        <div class="data-row">
          <div class="data-col col1">
            <div class="label-mobile">{{ $t('component.userData.account.labelEmail') }}</div>
            {{ user[0].email }}
          </div>
          <div class="data-col col2">
            <div class="label-mobile">{{ $t('component.userData.account.labelPassword') }}</div>
            **********
          </div>
          <div class="data-col col3">
            <el-button type="danger" icon="el-icon-delete" plain size="mini" @click="removeAccount">
              {{ $t('component.userData.account.buttonRemoveAccount') }}
            </el-button>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import AccountMixin from '@/common/mixins/UserData/Account.mixin'

export default {
  name: 'UserDataAccount',
  mixins: [AccountMixin]
}
</script>

<style src="../../assets/scss/table.scss" lang="scss"></style>
<style lang="scss">
@import '../../assets/scss/variables';
.user-data-account {
  @media (min-width: $res-m) {
    .col1 { width: 300px }
    .col2 { width: 160px }
    .col3 { width: auto }
  }
  @media (min-width: $res-l) {
    .col1 { width: 320px }
    .col2 { width: 320px }
    .col3 { width: auto }
  }
  @media (min-width: $res-xl) {
    .col1 { width: 380px }
    .col2 { width: 380px }
    .col3 { width: auto }
  }
}
</style>
